/* Svetla/tamna tema: atribut data-theme na <html> bira --ui-* tokene u index.css,
   a <link id="theme-link"> u index.html bira PrimeReact temu (public/themes/tacho-*, generiše scripts/build-themes.js).
   Izbor se pamti u localStorage.appTheme; bez izbora važi sistemska podešavanja (inline skript u index.html). */

const KEY = 'appTheme';
const THEMES = ['light', 'dark'];
const href = (t) => `${process.env.PUBLIC_URL || ''}/themes/tacho-${t}/theme.css`;

export const getTheme = () => (document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

/** Primeni temu; Promise se razrešava kad je PrimeReact stylesheet učitan (bez treptaja nestilizovanih kontrola). */
export const applyTheme = (theme) => {
    const t = THEMES.includes(theme) ? theme : 'light';
    try { localStorage.setItem(KEY, t); } catch { /* privatni režim */ }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', t === 'dark' ? '#0b110f' : '#163a2e');

    const old = document.getElementById('theme-link');
    if (!old || old.getAttribute('href') === href(t)) {
        document.documentElement.setAttribute('data-theme', t);
        return Promise.resolve(t);
    }
    return new Promise((resolve) => {
        const link = old.cloneNode();
        link.setAttribute('href', href(t));
        const done = () => {
            old.remove();
            link.id = 'theme-link';
            document.documentElement.setAttribute('data-theme', t);
            resolve(t);
        };
        link.id = 'theme-link-next';
        link.onload = done;
        link.onerror = done;
        old.after(link);
    });
};

/* Druga tema se učitava unapred (preload), pa promena ne čeka preuzimanje stila — zato je prelaz odmah gladak. */
const preload = () => {
    THEMES.forEach((t) => {
        if (document.querySelector(`link[data-preload-tema="${t}"]`)) return;
        const l = document.createElement('link');
        l.rel = 'preload'; l.as = 'style'; l.href = href(t); l.dataset.preloadTema = t;
        document.head.appendChild(l);
    });
};
if (typeof document !== 'undefined') {
    if (document.readyState === 'complete') preload(); else window.addEventListener('load', preload, { once: true });
}

/* Prelaz krugom iz prekidača (View Transitions API): nova tema se otkriva krugom sa mekom, senčenom ivicom
   (maska sa prelivom umesto oštrog clip-path), a stara tema za to vreme blago potamni (index.css). Kretanje je
   samo mask-size, pa je glatko i na slabijim računarima. Bez API-ja ili uz "smanji pokret" -> obična promena. */
export const toggleThemeWithReveal = (origin) => {
    const next = getTheme() === 'dark' ? 'light' : 'dark';
    const motionOk = !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!document.startViewTransition || !motionOk || !origin) return applyTheme(next);

    const transition = document.startViewTransition(() => applyTheme(next));
    transition.ready
        .then(() => {
            const { x, y } = origin;
            const r = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
            const d = Math.ceil(r * 2.6); // prečnik maske (meka ivica je spoljnih ~25%)
            document.documentElement.animate(
                {
                    maskImage: ['radial-gradient(circle closest-side, #000 72%, transparent 100%)', 'radial-gradient(circle closest-side, #000 72%, transparent 100%)'],
                    maskRepeat: ['no-repeat', 'no-repeat'],
                    maskPosition: [`${x}px ${y}px`, `${x - d / 2}px ${y - d / 2}px`],
                    maskSize: ['0px 0px', `${d}px ${d}px`],
                },
                { duration: 700, easing: 'cubic-bezier(.4, 0, .2, 1)', pseudoElement: '::view-transition-new(root)' }
            );
        })
        .catch(() => { /* prekinut prelaz — tema je već primenjena */ });
    return transition.finished.then(() => next).catch(() => next);
};
